import { TextareaInput } from "nystem-components";

const TextTextarea = ({ ...props }) => <TextareaInput {...props} />;

export default TextTextarea;
